import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

function useSessionDetails(sessionId, token) {
  const fetchSurveySession = async () => {
    try {
      const response = await api.get(`/sessions/${sessionId}/`, {
        params: { score: true },
        headers: { Authorization: token },
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch survey session');
    }
  };

  const queryKey = ['surveySession', sessionId, token];

  const { data, error, isLoading } = useQuery({
    queryKey,
    queryFn: fetchSurveySession,
    gcTime: Infinity,
    staleTime: Infinity,
    enabled: !!sessionId && !!token, // Only run query when both sessionId and token are available
  });

  return {
    surveySession: data,
    isLoading,
    error,
  };
}

export default useSessionDetails;
